"use strict";

var from         = require("es5-ext/array/from")
  , primitiveSet = require("es5-ext/object/primitive-set");

module.exports = primitiveSet.apply(null, from("\n\r\u2028\u2029"));
